const DOCUMENT_LABELS: Record<string, string> = {
  'offer-letter': 'Offer Letter',
  'offer-letter-v2': 'Letter of Offer',
  'discharge-letter': 'Discharge Letter',
  'extension-letter': 'Extension Letter',
  'settlement-statement': 'Settlement Statement',
};

export function getDocumentDisplayLabel(type: string): string {
  return DOCUMENT_LABELS[type] ?? type.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
}

export function buildDocumentGenerateUrl(loanId: string, type: string, extraId?: string): string {
  return extraId
    ? `/documents/generate/${loanId}/${type}/${extraId}`
    : `/documents/generate/${loanId}/${type}`;
}

export function extractFilenameFromDisposition(disposition?: string | null): string | null {
  if (!disposition) {
    return null;
  }

  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1]);
  }

  const standardMatch = disposition.match(/filename="?([^";]+)"?/i);
  return standardMatch?.[1] ?? null;
}

export function buildPdfFilename(filename?: string | null, fallbackTitle?: string): string {
  const source = (filename || fallbackTitle || 'document')
    .replace(/\.(html?|pdf)$/i, '')
    .trim()
    .replace(/[^A-Za-z0-9._-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

  return `${source || 'document'}.pdf`;
}
